/** The location fields that decide where inventory is counted. */
interface InventoryLocationCandidate {
  is_active?: boolean
  is_default?: boolean
}

/** Inventory is counted at the default active location, else the first active one. */
export function getCanonicalInventoryLocation<TLocation extends InventoryLocationCandidate>(
  locations: TLocation[] | null | undefined = []
): TLocation | null {
  const activeLocations = Array.isArray(locations)
    ? locations.filter((location) => location?.is_active === true)
    : []

  return (
    activeLocations.find((location) => location?.is_default === true) ?? activeLocations[0] ?? null
  )
}

export function canTrackInventoryForLocations(
  locations: InventoryLocationCandidate[] | null | undefined = []
): boolean {
  return getCanonicalInventoryLocation(locations) !== null
}
